<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Does the plan offer participant account auto rebalancing to a
              target allocation?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.auto_rebalancing_offered_yesno"
            >
              <roe-radio-input
                v-model="formData.auto_rebalancing_offered_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row">
          <div class="form-unit">
            <div class="common-label">
              Does your plan offer model portfolios built from the core
              investment options?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.portfolios_investments_yesno"
            >
              <roe-radio-input
                v-model="formData.portfolios_investments_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row" v-if="showModelsType">
          <div class="form-unit">
            <div class="light-label">
              Model portfolios built from the core investment options
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.mo_65_rk_models_type">
              <v-select
                v-model="formData.mo_65_rk_models_type"
                name="mo_65_rk_models_type"
                :options="[
                  { code: 1, label: 'Age Based' },
                  { code: 2, label: 'Risk Based' }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row">
          <div class="form-unit">
            <div class="common-label">
              Does the plan offer a Managed Account Option?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.managed_accounts_investments_yesno"
            >
              <roe-radio-input
                v-model="formData.managed_accounts_investments_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row" v-if="showProvider">
          <div class="form-unit">
            <div class="light-label">Name of provider</div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.ma_66_ma_provider">
              <input
                type="text"
                v-model="formData.ma_66_ma_provider"
                name="ma_66_ma_provider"
                required
                maxlength="60"
              />
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="common-label">
              Indicate the type of QDIA option for the plan
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.qdia_auto_divers_option_picklist_id"
            >
              <v-select
                v-model="formData.qdia_auto_divers_option_picklist_id"
                :options="[
                  { code: 1, label: 'Target Date Fund Series' },
                  { code: 2, label: 'Risk Based Fund Series' },
                  { code: 3, label: 'Hybrid Target/Risk Based Fund Series' },
                  { code: 4, label: 'LDI Fund Series' },
                  { code: 5, label: 'Balanced Fund' },
                  { code: 6, label: 'Model Portfolios from core options' },
                  { code: 7, label: 'Managed Account Option' },
                  { code: 8, label: 'No Designated QDIA' }
                ]"
                :reduce="label => label.code"
                name="qdia_auto_divers_option_picklist_id"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row form-row--center-full">
          <div class="form-unit">
            <div class="light-label">
              Has the plan defaulted ALL employees into the QDIA option?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.qdia_reenroll_option">
              <v-select
                v-model="formData.qdia_reenroll_option"
                name="qdia_reenroll_option"
                :options="[
                  { code: 1, label: 'No' },
                  { code: 2, label: 'Re-enrolled prior year' },
                  { code: 3, label: 'Re-enrolled current year' },
                  { code: 4, label: 'Re-enrolled every year' }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { mapMutations } from "vuex";
import {
  RESET_ATTRIBUTES,
  SET_INVALID_FORM_STATE
} from "@/store/mutations.type";
import { required, maxLength, requiredIf } from "vuelidate/lib/validators";
export default {
  name: "RoeInvestmentsForm",
  props: ["formData"],
  created() {
    this.setNextButtonState({ isInvalid: this.$v.$invalid });
  },
  watch: {
    "$v.$invalid": function(value) {
      this.setNextButtonState({ isInvalid: value });
    },
    "formData.portfolios_investments_yesno": function() {
      this.resetAttributes("portfolios_investments_yesno");
    },
    "formData.managed_accounts_investments_yesno": function() {
      this.resetAttributes("managed_accounts_investments_yesno");
    }
  },
  validations() {
    return {
      formData: {
        auto_rebalancing_offered_yesno: { required },
        portfolios_investments_yesno: { required },
        mo_65_rk_models_type: {
          required: requiredIf(() => this.showModelsType)
        },
        managed_accounts_investments_yesno: { required },
        ma_66_ma_provider: {
          required: requiredIf(() => this.showProvider),
          maxLength: maxLength(60)
        },
        qdia_auto_divers_option_picklist_id: { required },
        qdia_reenroll_option: { required }
      }
    };
  },
  computed: {
    showModelsType() {
      return +this.formData.portfolios_investments_yesno === 1;
    },
    showProvider() {
      return +this.formData.managed_accounts_investments_yesno === 1;
    }
  },
  components: {
    RoeErrorMessage,
    RoeRadioInput
  },
  methods: {
    ...mapMutations({
      resetAttributes: RESET_ATTRIBUTES,
      setNextButtonState: SET_INVALID_FORM_STATE
    })
  }
};
</script>
